import { z } from "zod";

import {
  OPTION_ORDER_TYPES,
  OPTION_TIME_IN_FORCE,
} from "~/v2/constants/optionOrder";
import { isGTZero } from "../shared/utils";

export const zOptionSchema = z.object({
  orderType: z.enum(OPTION_ORDER_TYPES),
  timeInForce: z.enum(OPTION_TIME_IN_FORCE),
  quantity: z.coerce.number().int("Quantity must be a whole number"),
  limitPrice: z.coerce.number().optional(),
  stopPrice: z.coerce.number().optional(),
});

export type OptionSchema = z.infer<typeof zOptionSchema>;

export const optionSchemaSuperRefinement = (
  { orderType, quantity, limitPrice, stopPrice }: OptionSchema,
  refinementContext: z.RefinementCtx,
) => {
  if (!Number.isInteger(quantity)) {
    refinementContext.addIssue({
      code: z.ZodIssueCode.custom,
      message: "Quantity must be a whole number",
      path: ["quantity"],
    });
  }

  if (!isGTZero(quantity)) {
    refinementContext.addIssue({
      code: z.ZodIssueCode.custom,
      message: "Quantity must be greater than 0",
      path: ["quantity"],
    });
  }

  if (
    (orderType === "limit" || orderType === "stop_limit") &&
    !isGTZero(limitPrice)
  ) {
    refinementContext.addIssue({
      code: z.ZodIssueCode.custom,
      message: "Limit Price must be greater than 0",
      path: ["limitPrice"],
    });
  }

  if (
    (orderType === "stop" || orderType === "stop_limit") &&
    !isGTZero(stopPrice)
  ) {
    refinementContext.addIssue({
      code: z.ZodIssueCode.custom,
      message: "Stop Price must be greater than 0",
      path: ["stopPrice"],
    });
  }
};
